import { takeEvery, put, call } from "redux-saga/effects";
import * as ACTIONS from "../../components/DynamicForm/actionTypes";
import * as dynamicFormActionCreators from "../../components/DynamicForm/actionCreators";
import endpoints, { endpointTypes } from "../../service";
import { fetchAPI } from "../../utils/service";

const propertyManagerRoute = endpoints[endpointTypes.PROPERTY_MANAGER];
export function* getPropertyManagers(action) {
    try {
        const endpoint = propertyManagerRoute.endpoints.getPropertyManagers();
        const response = yield call(fetchAPI, endpoint);
        if (response && response.data) {
            yield put(
                dynamicFormActionCreators.updatePropertyManagerList(
                    response.data.map((item) => {
                        return { label: item.companyName, id: item.id };
                    })
                )
            );
        } else {
            yield put(dynamicFormActionCreators.updatePropertyManagerList([]));
        }
    } catch (err) {
        yield put(dynamicFormActionCreators.updatePropertyManagerList([]));
    }
}

export function* fetchPropertyManagerList() {
    yield takeEvery(ACTIONS.GET_PROPERTY_MANAGER_LIST, getPropertyManagers);
}
